@if (isAuthenticated()) {
<div>
  <header>
    <nav class="fixed-top">
      <nav class="navbar navbar-light bg-card ps-4 py-0 breadcrumb-shadow row">
        <div class="d-flex">
          <div class="container-fluid col-5 mx-0 px-0">
              <ol class="breadcrumb my-2 flex-nowrap text-nowrap">
                <li class="breadcrumb-item text-truncate text-secondary" title="メール受信設定" style="font-size: 17px;color: rgb(33, 37, 41) !important;">
                  メール受信設定
                </li>
              </ol>
          </div>
        </div>
      </nav>
    </nav>
  </header>
</div>
<div class="content">
  <div style="position: fixed; top: 10px; left: 180px; z-index: 1031;">{{ envName }}</div>
  <router-outlet></router-outlet>
</div>
}
